import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import Autocomplete from "@mui/material/Autocomplete";
import Typography from "@mui/material/Typography";
import { Controller } from "react-hook-form";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import "dayjs/locale/th";
import { useEffect, useMemo } from "react";
import { useGetListPlantPartner } from "../services/useDataSourceApi";

dayjs.extend(buddhistEra);
dayjs.locale("th");

export const WaterMeterFormContent = ({
  control,
  register,
  errors,
  serialNumberList,
  aliasOptions,
  tansactionById,
  waterDetail,
  setValue,
}) => {

  const { data: plantPartnerList } = useGetListPlantPartner();

  const handleBranchNameChange = (newValue, field) => {
    if (newValue && typeof newValue === "object") {
      field.onChange(newValue.plant_name || "");
      setValue("branch_address", newValue.plant_address || "");
      setValue("company_tax_id", newValue.company_tax_id || "");
      setValue("company_address", newValue.company_address || "");
      setValue("plant_master_data_id", newValue.id || null);
      setValue("company_name", newValue.company_name || "");
      setValue("serial_number", newValue.sn_water_meter || "");
    } else {
      field.onChange(typeof newValue === "string" ? newValue : "");
    }
  };


  return (
    <>
        <Box>
            <Typography variant="h5" sx={{ mb: 1 }}>Customer Company</Typography>
            <Box sx={{ backgroundColor: "white", padding: "14px", borderRadius: "10px", border: "1px solid #E0E0E0"}}>
                <FormGroup>
                <Box>
                    <Typography variant="caption" color="textSecondary">Company Name <span style={{ color: "red" }}>*</span></Typography>
                    {/* <Controller
                    name="company_name"
                    control={control}
                    rules={{ required: "Company name is required" }}
                    render={({ field }) => (
                        <Autocomplete
                        {...field}
                        freeSolo
                        options={plantPartnerList || []}
                        getOptionLabel={(option) => option?.plant_name || option || ""}
                        value={field.value || null}
                        onChange={(_, newValue) => {
                            field.onChange(typeof newValue === "string" ? newValue : newValue?.plant_name || "");
                        }}
                        onInputChange={(_, newInputValue) => {
                            field.onChange(newInputValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            placeholder="Select company name"
                            error={!!errors?.company_name}
                            variant="outlined"
                            fullWidth
                            sx={{
                                ".MuiInputBase-root": {
                                width: "100%",
                                "& > .MuiInputBase-input": {
                                    height: "6px",
                                },
                                },
                                ".MuiOutlinedInput-notchedOutline": {
                                borderRadius: "8px",
                                },
                                ".Mui-error .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#FF5B5B",
                                },
                            }}
                            />
                        )}
                        />
                    )}
                    /> */}
                    <TextField
                    {...register("company_name", {
                        required: "Company name is required",
                    })}
                    placeholder="Enter company name"
                    error={!!errors?.company_name}
                    variant="outlined"
                    fullWidth
                    sx={{
                        ".MuiInputBase-root": {
                        width: "100%",
                        "& > .MuiInputBase-input": {
                            padding: "8px",
                        },
                        },
                        ".MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px",
                        },
                        ".Mui-error .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#FF5B5B",
                        },
                    }}
                    />
                </Box>
                <Box sx={{ mt: 1 }}>
                    <Typography variant="caption" color="textSecondary">Address</Typography>
                    <TextField
                    {...register("company_address")}
                    variant="outlined"
                    fullWidth
                    />
                </Box>
                <Box sx={{ mt: 1 }}>
                    <Typography variant="caption" color="textSecondary">
                    Company Tax ID <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                    {...register("company_tax_id", {
                        required: "Company tax ID is required",
                    })}
                    error={!!errors?.company_tax_id}
                    variant="outlined"
                    fullWidth
                    sx={{
                        ".MuiInputBase-root": {
                        width: "100%",
                        "& > .MuiInputBase-input": {
                            padding: "8px",
                        },
                        },
                        ".MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px",
                        },
                        ".Mui-error .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#FF5B5B",
                        },
                    }}
                    />
                </Box>
                </FormGroup>
            </Box>
        </Box>
        
        <Box sx={{ mt: 2 }}>
            <Typography variant="h5" sx={{ mb: 1 }}>Branch</Typography>
            <Box sx={{ backgroundColor: "white", padding: "14px", borderRadius: "10px", border: "1px solid #E0E0E0" }}>
                <Typography variant="caption" color="textSecondary">
                    Branch Name 
                </Typography>
                <Controller
                name="branch_name"
                control={control}
                render={({ field }) => (
                    <Autocomplete
                    freeSolo
                    options={plantPartnerList || []}
                    getOptionLabel={(option) => option?.plant_name || option || ""}
                    value={field.value || null}
                    onChange={(_, newValue) => {
                        handleBranchNameChange(newValue, field);
                    }}
                    onInputChange={(_, newInputValue, reason) => {
                        if (reason === "input") {
                        field.onChange(newInputValue);
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                        {...params}
                        placeholder="Select branch"
                        error={!!errors?.branch_name}
                        variant="outlined"
                        fullWidth
                        sx={{
                            ".MuiInputBase-root": {
                            width: "100%",
                            "& > .MuiInputBase-input": {
                                // padding: "8px",
                                height: "6px",
                            },
                            },
                            ".MuiOutlinedInput-notchedOutline": {
                            borderRadius: "8px",
                            },
                            ".Mui-error .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#FF5B5B",
                            },
                        }}
                        />
                    )}
                    />
                )}
                />
                <Box sx={{ mt: 1 }}>
                    <Typography variant="caption" color="textSecondary">Branch Address</Typography>
                    <TextField
                    {...register("branch_address")}
                    variant="outlined"
                    fullWidth
                    />
                </Box>
            </Box>
        </Box>

        <Box sx={{ mt: 2 }}>
            <Typography variant="h5" sx={{ mb: 1 }}>Bill Info</Typography>
            <Box sx={{ backgroundColor: "white", padding: "14px", borderRadius: "10px", border: "1px solid #E0E0E0"}}>
                <FormGroup>
                <Box>
                    <Typography variant="caption" color="textSecondary">
                    Date <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Controller
                    name="date"
                    control={control}
                    rules={{ required: "Date is required" }}
                    render={({ field, fieldState }) => (
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="th" dateFormats={{ year: "BBBB", monthAndYear: "MMMM BBBB" }}>
                        <DesktopDatePicker
                            {...field}
                            inputFormat="D MMMM BBBB"
                            disableMaskedInput
                            value={field.value ? dayjs(field.value) : null}
                            defaultCalendarMonth={tansactionById?.activity_date ? dayjs(`${tansactionById?.activity_date}-01`) : undefined}
                            onChange={(date) => {
                            field.onChange(date ? date.format("YYYY-MM-DD") : ""); // เก็บเป็น YYYY-MM-DD (ค.ศ.)
                            }}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                error={!!fieldState.error}
                                helperText={fieldState.error?.message}
                                fullWidth
                                sx={{
                                ".MuiOutlinedInput-notchedOutline": { borderRadius: "8px" },
                                ".Mui-error .MuiOutlinedInput-notchedOutline": { borderColor: "#FF5B5B" },
                                ".MuiInputBase-root": {
                                    width: "100%",
                                    "& > .MuiInputBase-input": {
                                    height: "6px",
                                    },
                                },
                                }}
                            />
                            )}
                        />
                        </LocalizationProvider>
                    )}
                    />
                </Box>

                <Box sx={{ mt: 1 }}>
                    <Typography variant="caption" color="textSecondary">
                    Serial Number <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Controller
                    name="serial_number"
                    control={control}
                    rules={{ required: "Serial number is required" }}
                    render={({ field }) => (
                        <Autocomplete
                        {...field}
                        freeSolo
                        options={serialNumberList}
                        getOptionLabel={(option) => option?.serial_number || option || ""}
                        value={field.value || null}
                        onChange={(_, newValue) => {
                            field.onChange(typeof newValue === "string" ? newValue : newValue?.serial_number || "");
                        }}
                        onInputChange={(_, newInputValue) => {
                            field.onChange(newInputValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            placeholder="Select serial number"
                            error={!!errors?.serial_number}
                            variant="outlined"
                            fullWidth
                            sx={{
                                ".MuiInputBase-root": {
                                width: "100%",
                                "& > .MuiInputBase-input": {
                                    height: "6px",
                                },
                                },
                                ".MuiOutlinedInput-notchedOutline": {
                                borderRadius: "8px",
                                },
                                ".Mui-error .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#FF5B5B",
                                },
                            }}
                            />
                        )}
                        />
                    )}
                    />
                </Box>

                <Box sx={{ mt: 1 }}>
                    <Typography variant="caption" color="textSecondary">
                    Meter Number <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                    {...register("meter_reading", {
                        required: "Meter reading is required",
                    })}
                    error={!!errors?.meter_reading}
                    variant="outlined"
                    fullWidth
                    sx={{
                        ".MuiInputBase-root": {
                        width: "100%",
                        "& > .MuiInputBase-input": {
                            padding: "8px",
                        },
                        },
                        ".MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px",
                        },
                        ".Mui-error .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#FF5B5B",
                        },
                    }}
                    />
                </Box>
                </FormGroup>
            </Box>
        </Box>

        
    </>
  );
};
